import { connect } from 'react-redux';
import SwitchFooter from './SwitchFooter';

const mapStateToProps = ({ scribeSession: { displayable } }) => ({
  displayable,
});

export default connect(mapStateToProps, {})(SwitchFooter);
